<template>
  <generic-create :model="model">
    <template v-slot:form="{ error, submit }">
      <person-role-form :error="error" :loading="false" @submit="submit" />
    </template>
  </generic-create>
</template>

<script>
import PersonRoleForm from "./Form"
import model from "./model"

export default {
  components: { PersonRoleForm },
  data() {
    return { model }
  },
}
</script>
